"use client";

import { useRouter, usePathname, useSearchParams } from "next/navigation";
import React from "react";

import { useTranslations } from "next-intl";

import { SortSelect as UISortSelect } from "@/components/ui/SearchResultHeader/SortSelect";
import { cn } from "@/utils/cn";

interface SortOption {
  key: string;
  label: string;
  value: string;
}

interface SortSelectProps {
  currentSort: string;
  className?: string;
}

export const SortSelect: React.FC<SortSelectProps> = ({
  currentSort,
  className,
}) => {
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const sortOptions: SortOption[] = [
    {
      key: "price_asc",
      label: t("Price: low to high"),
      value: "price_asc",
    },
    {
      key: "price_desc",
      label: t("Price: high to low"),
      value: "price_desc",
    },
    {
      key: "rooms_asc",
      label: t("Rooms: low to high"),
      value: "rooms_asc",
    },
    {
      key: "rooms_desc",
      label: t("Rooms: high to low"),
      value: "rooms_desc",
    },
  ];

  const handleSortChange = (sortValue: string) => {
    const params = new URLSearchParams(searchParams.toString());

    if (sortValue) {
      params.set("sortBy", sortValue);
    } else {
      params.delete("sortBy");
    }

    router.push(`${pathname}?${params.toString()}`);
  };

  return (
    <div className={cn("min-w-[200px] h-[5.4rem]", className)}>
      <UISortSelect
        className={className}
        value={currentSort}
        options={sortOptions}
        onChange={handleSortChange}
      />
    </div>
  );
};
